// packages import
import { Box, Button, CircularProgress, DialogActions, Typography } from "@mui/material"
import { FC, useContext } from "react"
// component import
import { Alert } from "../common/Alert"
import { CustomModal } from "../common/CustomModal"
// others
import { useRemoveCourtMutation } from "../../../generated"
import { CANCEL, NOT_APPLICABLE } from "../../constants"
import { AppContext } from "../../context"
import { ActionType } from "../../context/AppContextReducer"
import { DispatchAndState, ErrorException } from "../../interfaceTypes"
import { titleize } from "../../utils"
import { CourtAction, CourtState } from "./CourtReducer"

export const DeleteCourt: FC<DispatchAndState<CourtState, CourtAction>> = ({ state, refetch }) => {
  const { isDeleteOpen, dispatch } = useContext(AppContext)
  const { currentCourt } = state || {}
  const { county, id, name } = currentCourt || {}

  const handleClose = () => {
    dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: false })
  }

  const [removeCourt, { loading }] = useRemoveCourtMutation({
    onError(error) {
      const { graphQLErrors } = error

      if (graphQLErrors) {
        graphQLErrors.map(
          // eslint-disable-next-line
          ({ extensions }) => {
            if (extensions) {
              const { exception } = extensions;
              if (exception) {
                const { response } = exception as ErrorException
                const { response: errorResponse } = response || {}
                if (errorResponse) {
                  const { error } = errorResponse
                  Alert.error(error)
                }
              }
            }
          })
      }
    },

    onCompleted(data) {
      if (data) {
        const { removeCourt } = data
        const { response } = removeCourt || {}
        const { status } = response || {}

        if (status === 200) {
          refetch && refetch()
          Alert.success('Court deleted successfully')
          handleClose();
        }
      }
    }
  })

  const handleDelete = async () => {
    if (id) {
      await removeCourt({
        variables: {
          removeCourt: {
            id
          }
        }
      });
    }
  }

  return (
    <CustomModal title="Delete Court" isOpen={isDeleteOpen} handleClose={handleClose}>
      <Typography variant="body1">You are about to delete the following court:</Typography>

      <Box mt={1}>
        <Typography variant="body1" textTransform='capitalize'>
          <Typography component='span' fontWeight={500}>Court Name: </Typography> {titleize(name || '')}
        </Typography>

        <Typography variant="body1" textTransform='capitalize'>
          <Typography component='span' fontWeight={500}>County: </Typography>
          {titleize(county || NOT_APPLICABLE)}
        </Typography>
      </Box>

      <DialogActions sx={{ padding: '30px 0 0', flexWrap: 'wrap', }}>
        <Button onClick={handleClose} variant='outlined' aria-label={CANCEL}>{CANCEL}</Button>

        <Button
          disabled={loading}
          onClick={handleDelete} color='primary' variant="contained" aria-label='delete court'
          endIcon={loading && <CircularProgress size={20} color="inherit" />}
        >
          Delete Court
        </Button>
      </DialogActions>
    </CustomModal>
  )
}